import { toSentenceCase } from '../../utils';

export const makeColumns = (cols, columnsKeyNames, renderEditableCell) => {
  const columns = [];
  cols.forEach((col, i) => {
    columns.push({
      Header: toSentenceCase(col.name),
      accessor: columnsKeyNames?.[i],
      headerClassName: 'sort',
      Cell: renderEditableCell,
    });
  });
  return columns;
};

export const makeRows = (columnsKeyNames, rows) => {
  const entries = [];
  rows.forEach((row) => {
    const formattedRow = {};
    row.forEach((cellValue, i) => {
      formattedRow[columnsKeyNames?.[i]] = String(cellValue).trim();
    });
    entries.push({
      ...formattedRow,
    });
  });
  return entries;
};

export const SheetJSFT = [
  'xlsx',
  'xlsb',
  'xlsm',
  'xls',
  'xml',
  'csv',
  'txt',
  'ods',
  'fods',
  'uos',
  'sylk',
  'dif',
  'dbf',
  'prn',
  'qpw',
  '123',
  'wb*',
  'wq*',
  'html',
  'htm',
]
  .map((x) => `.${x}`)
  .join(',');

export const downloadCsvFile = async (data, name) => {
  const { default: XLSX } = await import('xlsx');

  // generate worksheet from state data
  const worksheet = XLSX.utils.aoa_to_sheet(data);

  // create workbook and append worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, name);

  // export to csv and download
  XLSX.writeFile(workbook, `${name}.csv`, { bookType: 'csv' });
};
